import { useSelector } from 'react-redux';
import React, { useMemo } from 'react';

import { emptyArray, emptyObject } from 'ui-components/default-props/empty';
import Global from '../../../store/global-selectors';
import PrintDocumentButton from '../../../components/print-document-button';
import PrintOrderSummaryHotkey from '../../../components/hotkeys/advanced-hotkeys/print-order-summary';
import PrintPackingSlipHotkey from '../../../components/hotkeys/advanced-hotkeys/print-packing-slip';
import PrintPickListHotkey from '../../../components/hotkeys/advanced-hotkeys/print-pick-list';

import { CustomsForm } from './components/customs-form';
import { Label } from './components/label';
import { OrderSummary } from './components/order-summary';
import { PackingSlip } from './components/packing-slip';
import { PickList } from './components/pick-list';
import { ShipmentManifest } from './components/shipment-manifest';
import { useOrderSummary } from './hooks/use-order-summary';
import { usePackingSlip } from './hooks/use-packing-slip';
import { usePickList } from './hooks/use-pick-list';

export const ShipmentsGridPrintDocumentButton = (props) => {
  const selectedFulfillmentIds = useSelector(Global.selectSelectedShipmentsSelectedShipmentIds) || emptyArray;
  const selectedFulfillmentPlanIds = useSelector(
    (state) =>
      Global.selectEntitiesFPIdsByFulfillmentIds(state, {
        fulfillmentIds: selectedFulfillmentIds,
      }) || emptyArray,
  );

  const isDisabled = !selectedFulfillmentIds.length;
  const fulfillments =
    useSelector((state) =>
      Global.selectEntitiesFulfillmentsByIds(state, {
        fulfillmentIds: selectedFulfillmentIds,
      }),
    ) || emptyArray;
  const fulfillmentPlans =
    useSelector((state) =>
      Global.selectEntitiesFulfillmentPlansByIds(state, {
        fulfillmentPlanIds: selectedFulfillmentPlanIds,
      }),
    ) || emptyArray;
  const selectedData = useMemo(() => {
    return fulfillments.map(({ fulfillmentId, fulfillmentPlanId, labelFulfillment }) => {
      const selectedFulfillmentPlan = fulfillmentPlans.find((fp) => fp.fulfillmentPlanId === fulfillmentPlanId) || emptyObject;

      return {
        fulfillmentId,
        fulfillmentPlanId,
        isLabelVoided: labelFulfillment?.isLabelVoided,
        isLabelCreated: !!labelFulfillment?.labelCreatedDateTime,
        isPackingSlipPrinted: selectedFulfillmentPlan.packingSlipPrintedStatus?.isPackingSlipPrinted,
      };
    });
    // we really only want to update memo when selected IDs change
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFulfillmentIds, selectedFulfillmentPlanIds]);

  const { isDisabled: orderSummaryIsDisabled, onClick: orderSummaryHotkeyHandler } = useOrderSummary({ fulfillments: selectedData });
  const { isDisabled: packingSlipIsDisabled, onClick: packingSlipHotkeyHandler } = usePackingSlip({ fulfillments: selectedData });
  const { isDisabled: pickListIsDisabled, onClick: pickListHotkeyHandler } = usePickList({ fulfillments: selectedData });

  return (
    <React.Fragment>
      {!orderSummaryIsDisabled && <PrintOrderSummaryHotkey handler={orderSummaryHotkeyHandler} />}
      {!packingSlipIsDisabled && <PrintPackingSlipHotkey handler={packingSlipHotkeyHandler} />}
      {!pickListIsDisabled && <PrintPickListHotkey handler={pickListHotkeyHandler} />}
      <PrintDocumentButton {...props} disabled={isDisabled} theme='tertiary'>
        <PackingSlip selectedData={selectedData} />
        <Label selectedData={selectedData} />
        <PickList selectedData={selectedData} />
        <CustomsForm selectedData={selectedData} />
        <ShipmentManifest selectedData={selectedData} />
        <OrderSummary selectedData={selectedData} />
      </PrintDocumentButton>
    </React.Fragment>
  );
};
